import { GlobalComposable } from "~/classes/composable/GlobalComposable"
import { defaultUserInterfaceSettings } from "~/utils/flatbuffers/user"

class Preview extends GlobalComposable<{
  dropdownOpen: boolean
  previewFadeOnDwell: boolean
  /** This is managed in the PreviewView component */
  isFaded: boolean
}> {
  readonly DWELL_DELAY_MS = 3000
  override defaultState = () => ({
    dropdownOpen: false,
    previewFadeOnDwell: defaultUserInterfaceSettings().previewFadeOnDwell,
    isFaded: false,
  })

  override onCreate = () => {
    const { addInterfaceEventListener } = useEvents()
    addInterfaceEventListener("afterNavigatedToNonFolderFile", this.onNavigatedToFile)
  }

  override onDestroy = () => {
    const { removeInterfaceEventListener } = useEvents()
    removeInterfaceEventListener("afterNavigatedToNonFolderFile", this.onNavigatedToFile)
  }

  override use = () => {
    const { userInterfaceSettings } = useSelf()
    this.state = useState(`use-${this.name}`, this.defaultState)
    watch(userInterfaceSettings, (settings) => {
      this.state.value.previewFadeOnDwell = settings.previewFadeOnDwell
    })
    return this
  }

  setFadeOnDwell = (previewFadeOnDwell: boolean) => {
    const { isAuthenticated, persistUserInterfaceSettings } = useSelf()
    this.state.value.previewFadeOnDwell = previewFadeOnDwell
    if (isAuthenticated.value)
      persistUserInterfaceSettings({ previewFadeOnDwell })
  }

  onNavigatedToFile = (file: InterfaceFile) => {
    const { setFileAccessedIfAllowed } = useFileSystem()
    setFileAccessedIfAllowed(file)
  }

  /**
   * The user may choose to make navigation elements fade on mouse dwell. This computed
   * property tells us whether a nav element should be hidden at this moment.
   */
  shouldNavElementsBeHidden = computed(() => {
    const { isOnPreviewPage } = useNavigation()
    return isOnPreviewPage() && this.state.value.previewFadeOnDwell && this.state.value.isFaded
  })
}

const preview = new Preview("preview", theme.colors.green.hex)
export default function () {
  return preview.use()
}
